import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ReportsAbstractService } from './reports-abstract.service';

@Injectable()
export class GatewayTransactionReportService extends ReportsAbstractService {
  public reportRoute: string = 'gateway_transaction_report';

  constructor(protected http: HttpClient) {
    super(http);
    this.route = this.reportRoute;
  }
}
